<div class="formulaOperatorsContainer">
  <div>{{ 'operators' | ppTranslate }}:</div>
  <div class="formulaOperators">
    @for (operator of operators; track operator) {
      <pp-formula-piece
        class="formulaOperator"
        [ppFormulaPiece]="operator"
        (click)="addOperator(operator)"
      ></pp-formula-piece>
    }
  </div>
</div>
